import React, { useState, useEffect } from "react"
import styled from "styled-components"

import MetaData from "@/common/components/MetaData"
import ResetCSS from "@/common/assets/css/style"
import ResultCard from "@/containers/MoneyFortune/View/result/ResultCard"
import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Result() {
  const [resultPageData, setResultPageDate] = useState({})
  useEffect(() => {
    const resultfilter = ResultDate.filter(value => {
      return value.roleID === "Oldman"
    })[0]

    setResultPageDate(resultfilter)
  }, [])

  return (
    <Wrapper>
      <MetaData
        title={`我的代表人物是 佛系賺錢法 - 老子`}
        description="比起獲利更重視安全的你，將資產分散放在多個信任的地方，在投資之前細心思量、慎選標的，在市場起伏大的時候，長期的投資報酬率也相當驚人。"
        url={`https://www.kryptogo.com/money-fortune/Oldman`}
        image="https://i.ibb.co/PmL9Fvp/OG-LaoZi.webp"
      />
      <ResetCSS />
      <ResultCard
        key={resultPageData.roleID}
        name={resultPageData.name}
        AKA={resultPageData.AKA}
        chance={resultPageData.chance}
        saying={resultPageData.saying}
        summary={resultPageData.summary}
        analysis={resultPageData.analysis}
        investment={resultPageData.investment}
        befit={resultPageData.befit}
        img={resultPageData.img}
        type="share"
        GetAndShare={GetAndShare}
        API={GetAndShare.API}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  * {
    ::-webkit-scrollbar-thumb {
      background: #00fff0;
      border-radius: 5px;
    }
    ::-webkit-scrollbar {
      width: 2px;
      background-color: none;
    }
  }
`
